import { EEsignatureStatuses } from "../../../../../constant/EEsignatureStatuses";
import { enrollSteps } from "../../../../../constant/expressEnrollment";

/**
 * Get current step (1-indexed) based on application form status.
 *
 * @param {Object} applicationForm - The application form object.
 * @returns {number} Current step (1-4).
 */
export const getCurrentStep = (applicationForm) => {
  if ([EEsignatureStatuses.SUBMITTED].includes(applicationForm?.status)) {
    return enrollSteps.DONE;
  }
  if (
    [
      EEsignatureStatuses.SIGNED,
      EEsignatureStatuses.SUBMISSION_IN_PROGRESS,
      EEsignatureStatuses.SUBMIT_FAILED
    ].includes(applicationForm?.status)
  ) {
    return enrollSteps.THIRD_STEP;
  }
  if (applicationForm?.attachmentName && applicationForm?.status !== EEsignatureStatuses.DRAFT) {
    return enrollSteps.SECOND_STEP;
  }
  return enrollSteps.FIRST_STEP;
};
